<template>
    <div class="school-detail-box news-detail-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/gk_guide' }">高考百科</el-breadcrumb-item>
            <el-breadcrumb-item>选考科目要求详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="news-detail-content">
			<el-col :span="16" style="padding-right: 64px">
				<p>{{newsInfor.news_title}}</p>
				<div class="news-detail-date">{{newsInfor.create_time|formatDate}}<span>{{newsInfor.browse_count}}次浏览</span></div>
				<div v-html="newsInfor.news_content" class="news-information"></div>
			</el-col>
			<el-col :span="8" style="padding-left:10px">
				<News class="news-right"></News>
			</el-col>
        </el-row>
    </div>
</template>

<script>
import { getNewsDetail } from '@/api/news'
export default {
	data() {
		return {
			id: '',
			newsInfor: '',
		}
	},
	filters: {
		formatDate: function(time) {
		time = time * 1000
		let date = new Date(time);
		let YY = date.getFullYear();
		let MM = date.getMonth() + 1;
		let DD = date.getDate();
		return YY + '.' + MM + '.' + DD;
		}
	},
	watch: {
		 $route: {
			handler: function (route) {
				this.redirect = route.query && route.query.redirect;
				this.id = this.$route.query.id;
				this.getNewsDetailHandler();
			},
			immediate: true,
		},
	},
	created() {
		this.$store.commit('user/ADDCOUNT', 0);
	},
	methods: {
		getNewsDetailHandler() {
			getNewsDetail(this.id).then(res => {
				this.newsInfor = res.data;
			}).catch(error => {console.log(error);})
		}
	}
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
	.news-detail-box {
		border-top: 4px solid #f5f7fa;
	}
    .news-detail-bg {
		@include gwidth;
		height: 120px;
		background: url('../../assets/images/newsDetail.png') no-repeat;
		background-size: 100% 100%;
		margin-top: 24px;
		padding: 32px 48px;
	}
	.news-detail-content {
		@include gwidth;
		margin-top: 24px;
		text-align: center;
		box-sizing: border-box;
		p {
			font-size: 32px;
			font-weight: 600;
			color: #2c2e33;
			margin: 0;
			line-height: 45px;
		}
		.news-detail-date {
			font-size: 14px;
			font-weight: 400;
			color: #909399;
			margin: 16px 0 24px 0;
			text-align: left;
			span {
				margin-left: 24px;
			}
		}
	}
	.news-information {
		font-size: 16px!important;
		font-weight: 400!important;
		color: #5e6166!important;
		text-align: left!important;
		line-height: 28px!important;
	}
	.news-right {
		box-shadow: none;
		background: #ffffff;
		border: 1px solid #f5f7fa;
		border-radius: 10px;
	}
</style>